// @ts-nocheck
/* eslint-disable max-len */
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";

import Card from '../../../ui/Card';
import Button from '../../../ui/Button';
import IconButton from '../../../ui/IconButton';
import Pill from '../../../ui/Pill';
import Empty from '../../../ui/Empty';
import Spinner from '../../../ui/Spinner';
import Progress from '../../../ui/Progress';
import Table, {
  Th, Td, Tr, TableToolbar, TablePager,
} from '../../../ui/Table';
import {
  PlusIcon, EditIcon, TrashIcon, AlertTriangleIcon, ClipboardIcon,
} from '../../../ui/icons';
import { TABLE_ITEMS_PER_PAGE } from '../../../../enums';

class Overview extends Component {
  state = { activePage: 1 }

  componentDidMount() {
    // Refetch on mount in case initAppState skipped (missing clientId, etc.).
    const { forms } = this.props.store;
    if (!forms.loading && Object.keys(forms.formLinks).length === 0) {
      forms.getFormLinks();
    }
  }

  snippetCell = (url) => {
    const { forms } = this.props.store;
    if (forms.loading && forms.currentUrl === url) {
      return <Spinner size={14} />;
    }
    const status = forms.formLinks[url].snippetStatus;
    if (status === false) {
      return (
        <button
          type="button"
          onClick={() => forms.verifySnippetInstall(url)}
          className="cursor-pointer inline-flex items-center gap-1.5"
          style={{ background: 'transparent', border: 0, padding: 0 }}
        >
          <Pill tone="amber" dot>Not installed · verify</Pill>
        </button>
      );
    }
    if (status) {
      return (
        <button
          type="button"
          onClick={() => forms.verifySnippetInstall(url)}
          className="cursor-pointer inline-flex items-center gap-1.5"
          style={{ background: 'transparent', border: 0, padding: 0 }}
        >
          <Pill tone="green" dot>Tracking</Pill>
        </button>
      );
    }
    return <Pill tone="gray">—</Pill>;
  }

  render() {
    const { add, edit, remove, store } = this.props;
    const paidPlan = typeof store.auth.paidPlan === 'function' ? store.auth.paidPlan() : store.auth.paidPlan;
    const { urlsInProgress, formLinks } = store.forms;
    const urls = Object.keys(formLinks);
    const totalPages = Math.ceil(urls.length / TABLE_ITEMS_PER_PAGE) || 1;
    const start = (this.state.activePage - 1) * TABLE_ITEMS_PER_PAGE;
    const slice = urls.slice(start, start + TABLE_ITEMS_PER_PAGE);

    const isEmpty = urls.length === 0 && urlsInProgress.length === 0;

    return (
      <Card padded={false}>
        <TableToolbar
          title="Your forms"
          count={urls.length}
          right={(
            <Button variant="primary" icon={PlusIcon} onClick={add}>Add a form</Button>
          )}
        />
        {isEmpty ? (
          <div className="p-5">
            <Empty
              icon={ClipboardIcon}
              title="No forms yet"
              sub="Add a URL to start tracking abandons and submissions."
              actions={<Button variant="primary" icon={PlusIcon} onClick={add}>Add your first form</Button>}
            />
          </div>
        ) : (
          <>
            <Table>
              <thead>
                <tr>
                  <Th>Form URL</Th>
                  <Th align="left">Snippet status</Th>
                  <Th align="right">Actions</Th>
                </tr>
              </thead>
              <tbody>
                {urlsInProgress.map((url) => (
                  <Tr key={`progress-${url}`} hoverable={false}>
                    <Td>
                      <span className="inline-flex items-center gap-2 text-mov-warn-ink">
                        <AlertTriangleIcon size={14} />
                        <span>Adding form at <b><u>{url}</u></b></span>
                      </span>
                    </Td>
                    <Td colSpan={2}>
                      <div className="flex items-center gap-2">
                        <Progress percent={100} tone="amber" />
                        <span className="text-[11.5px] mov-mono text-mov-ink-mute">Fetching</span>
                      </div>
                    </Td>
                  </Tr>
                ))}
                {slice.map((url) => (
                  <Tr key={url}>
                    <Td>
                      <a
                        href={`https://${url}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-mov-accent-ink hover:underline"
                      >
                        {`https://${url}`}
                      </a>
                    </Td>
                    <Td>{this.snippetCell(url)}</Td>
                    <Td align="right">
                      <div className="inline-flex items-center gap-1 justify-end">
                        {paidPlan && (
                          <IconButton
                            variant="ghost"
                            icon={EditIcon}
                            ariaLabel="Edit form"
                            onClick={() => edit(url)}
                          />
                        )}
                        <IconButton
                          variant="ghost"
                          icon={TrashIcon}
                          ariaLabel="Remove form"
                          onClick={() => remove(url)}
                        />
                      </div>
                    </Td>
                  </Tr>
                ))}
              </tbody>
            </Table>
            <TablePager
              page={this.state.activePage}
              totalPages={totalPages}
              total={urls.length}
              onChange={(p) => this.setState({ activePage: p })}
            />
          </>
        )}
      </Card>
    );
  }
}

export default inject('store')(observer(Overview));
